import { Component , TemplateRef, ViewChild, PLATFORM_ID ,Inject, OnInit,Output, EventEmitter } from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { MatDialogModule,MAT_DIALOG_DATA,MatDialogRef } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

import { MatDialog } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';


@Component({
  selector: 'app-list-remove',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    FormsModule],
  templateUrl: './list-remove.component.html',
  styleUrl: './list-remove.component.css'
})
export class ListRemoveComponent {

  shareLink: string;
  buttonText: string = 'Copy Text';
  buttonImage: string = '';
  buttonTextColor: string = '#EEA21A'; // Color inicial

  errorMsg: string | null = null;
  proyectos: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<ListRemoveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard
  ) {
    this.shareLink = data.shareLink;
    this.errorMsg = data.errorMsg || null;
    this.proyectos = data.proyectos || [];
  }

  deleteProyect() { 
    // Cerrar el diálogo y pasar true como resultado 
    this.dialogRef.close(true);
  }

    
}
